module.exports = __webpack_public_path__ + "static/media/icon-pending.1539bbf6.svg";